import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { DeliveryIdentity } from "@App/Pages/VehicleDelivery/DeliveryIdentity";
import { DeliveryDetails } from "@App/Pages/VehicleDelivery/DeliveryDetails";
import { DeliverySubmit } from "@App/Pages/VehicleDelivery/DeliverySubmit";
import { DeliverySummary } from "@App/Pages/VehicleDelivery/DeliverySummary";
import { useNavigateWithQueryParams } from "@App/hooks/useNavigateWithQueryParams";

/**
 * The funnel for the vehicle delivery service.
 *
 * @constructor
 */
export const VehicleDelivery: FunctionComponent = () => {
  const { navigateWithQuery } = useNavigateWithQueryParams();

  return (
    <Routes>
      <Route
        path={"/"}
        element={<DeliveryIdentity onSubmit={() => navigateWithQuery("details")} />}
      />
      <Route
        path={"/details"}
        element={<DeliveryDetails onSubmit={() => navigateWithQuery("../zusammenfassung", true)} />}
      />
      <Route
        path={"/zusammenfassung"}
        element={<DeliverySubmit onSubmit={() => navigateWithQuery("../danke", true)} />}
      />
      <Route path={"/danke"} element={<DeliverySummary />} />
    </Routes>
  );
};
